import { signIn } from '../api/auth';
import {
  validatePassword,
  validateUsername,
} from '../validations/loginValidations';

export interface ILoginCreds {
  username: string;
  password: string;
}

export interface IRegisterCreds {
  role: string;
  fullname: string;
  email: string;
  username: string;
  password: string;
}

export interface ILoginErrorsMsg {
  usernameError: string;
  passwordError: string;
  apiResponse: string;
}



export interface IRegisterCred {
  fullName: string;
  email: string;
  userName: string,
  password: string
}

export function generateIntialErrorMsg(): ILoginErrorsMsg {
  return {
    usernameError: '',
    passwordError: '',
    apiResponse: '',
  };
}

export async function validateLoginInfo(data: ILoginCreds) {
  let apiResponse;
  try {
    apiResponse = await signIn({ username: data.username, password: data.password });
  } catch (error: any) {
    apiResponse = error.response.data; // Set a custom error message
  }

  return {
    usernameError: validateUsername(data.username),
    passwordError: validatePassword(data.password),
    apiResponse // Set to null if no error, or a message if signIn failed
  };
}


